export default __webpack_public_path__ + "static/media/google.0eb97bcd.jpg";